import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const p=t("spain",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5H24V20.5H0V4.5Z"
                fill="white" />
            <path
                d="M0 4.5H24V8.76667H0V4.5ZM0 16.2333H24V20.5H0V16.2333Z"
                fill="#D03433" />
            <path
                d="M0 8.75684H24V16.2422H0V8.75684Z"
                fill="#FBCA46" />
            <path
                d="M8.31982 11.9668H9.38649V12.5001H8.31982V11.9668Z"
                fill="white" />
            <path
                d="M7.68004 13.5669C7.68004 13.8869 8.00004 14.1003 8.32004 14.1003C8.64004 14.1003 8.96004 13.8869 8.96004 13.5669L9.06671 11.9669H7.57337L7.68004 13.5669ZM7.04004 11.9669C7.04004 11.6469 7.25337 11.4336 7.46671 11.4336H9.06671C9.38671 11.4336 9.60004 11.6469 9.60004 11.8603V11.9669L9.49337 13.5669C9.38671 14.2069 8.96004 14.6336 8.32004 14.6336C7.68004 14.6336 7.25337 14.2069 7.14671 13.5669L7.04004 11.9669Z"
                fill="#A41517" />
            <path
                d="M7.25332 12.4997H9.38665V13.033H8.85332L8.31999 14.0997L7.78665 13.033H7.25332V12.4997ZM5.65332 10.8997H6.71999V14.633H5.65332V10.8997ZM9.91999 10.8997H10.9867V14.633H9.91999V10.8997ZM7.25332 10.3663C7.25332 10.0463 7.46665 9.83301 7.78665 9.83301H8.85332C9.17332 9.83301 9.38665 10.0463 9.38665 10.3663V10.5797C9.38665 10.793 9.27999 10.8997 9.06665 10.8997H7.46665C7.35999 10.8997 7.25332 10.793 7.25332 10.6863V10.3663Z"
                fill="#A41517" />
        </svg>
    `),l=i`
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        static>
        <mask
            id="mask0_4915_40025"
            style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="25">
            <circle
                cx="12"
                cy="12.5"
                r="12"
                fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_4915_40025)">
            <g clip-path="url(#clip0_4915_40025)">
                <path
                    d="M-6.52344 0.49707H29.4064V24.4971H-6.52344V0.49707Z"
                    fill="white" />
                <path
                    d="M-6.52344 0.49707H29.4064V6.89707H-6.52344V0.49707ZM-6.52344 18.0971H29.4064V24.4971H-6.52344V18.0971Z"
                    fill="#D03433" />
                <path
                    d="M-6.52344 6.88281H29.4064V18.1109H-6.52344V6.88281Z"
                    fill="#FBCA46" />
                <path
                    d="M5.93213 11.6973H7.52901V12.4973H5.93213V11.6973Z"
                    fill="white" />
                <path
                    d="M4.97424 14.0975C4.97424 14.5775 5.45331 14.8975 5.93237 14.8975C6.41144 14.8975 6.8905 14.5775 6.8905 14.0975L7.05019 11.6975H4.81455L4.97424 14.0975ZM4.01611 11.6975C4.01611 11.2175 4.33549 10.8975 4.65487 10.8975H7.05019C7.52925 10.8975 7.84863 11.2175 7.84863 11.5375V11.6975L7.68894 14.0975C7.52925 15.0575 6.8905 15.6975 5.93237 15.6975C4.97424 15.6975 4.33549 15.0575 4.1758 14.0975L4.01611 11.6975Z"
                    fill="#A41517" />
                <path
                    d="M4.33526 12.4971H7.52903V13.2971H6.73059L5.93214 14.8971L5.1337 13.2971H4.33526V12.4971ZM1.93994 10.0971H3.53682V15.6971H1.93994V10.0971ZM8.32747 10.0971H9.92435V15.6971H8.32747V10.0971ZM4.33526 9.29707C4.33526 8.81707 4.65464 8.49707 5.1337 8.49707H6.73059C7.20965 8.49707 7.52903 8.81707 7.52903 9.29707V9.61707C7.52903 9.93707 7.36934 10.0971 7.04996 10.0971H4.65464C4.49495 10.0971 4.33526 9.93707 4.33526 9.77707V9.29707Z"
                    fill="#A41517" />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_4915_40025">
                <rect
                    width="36"
                    height="24"
                    fill="white"
                    transform="translate(-6.52344 0.480469)" />
            </clipPath>
        </defs>
    </svg>
`,s=t("spain_rounded",l),e=t("ESP",l);export{e as ESP,p as Spain,s as SpainRounded};
